import {I18N} from 'aurelia-i18n';
import {autoinject} from 'aurelia-framework';

@autoinject()
export class LanguageChooserCustomAttribute {
  navEvent: any;
  lang: string;
  value: string;
  activeLang: string;

  constructor(
    private element: Element,
    private i18n: I18N) {

  }

  bind() {
    this.lang = this.value;
  }

  attached() {

    const lang = this.i18n.getLocale();
    if (lang == this.lang) {
      this.element.classList.add('active');
    } else {
      this.element.classList.remove('active');
    }

  }

  detached() {
  }
}
